import { QGetSettledBets } from "./QGetSettledBets";
export const QueryBuilder = {
    getSettledBets: QGetSettledBets
};
//# sourceMappingURL=index.js.map